import { useCallback, useRef, useState } from "react";
import { LuDownload } from "react-icons/lu";
import { getAbandonedCarts } from "../../../../api/orders";
import { TableLayout } from "../../layouts/table";
import { OrdersList } from "../orders/list";
import "../orders/style.css";

export const Carts = () => {
  const [period, setPeriod] = useState("30days");
  const exportView = useRef(null);
  const [canExport, setCanExport] = useState(false);
  const onExportView = useCallback((value) => {
    exportView.current = value;
    setCanExport(Boolean(value));
  }, []);
  return (
    <section className="ordersReference">
      <div className="topContainer">
        <div className="pageHeading">
          <h1 className="bodyTitle">Carritos</h1>
        </div>
        <div className="ordersHeadingActions">
          <button
            type="button"
            disabled={!canExport}
            onClick={() => exportView.current?.()}
          >
            <LuDownload aria-hidden="true" /> Exportar
          </button>
          <label>
            <span className="visually-hidden">Periodo de carritos</span>
            <select
              value={period}
              onChange={(event) => setPeriod(event.target.value)}
            >
              <option value="30days">Últimos 30 días</option>
              <option value="7days">Últimos 7 días</option>
              <option value="all">Todo el historial disponible</option>
            </select>
          </label>
        </div>
      </div>
      <p className="ordersMetricScope">
        Carritos abandonados que todavía no han generado un pedido. Las cestas
        activas de venta se gestionan desde el TPV o la tienda.
      </p>
      <TableLayout
        key="carts"
        get={getAbandonedCarts}
        idKey="shoppingCartId"
        identificator="abandonedCarts"
        emptyTitle="No hay carritos abandonados"
        emptyDescription="Los carritos abandonados aparecerán aquí."
        renderContent={(rows) => (
          <OrdersList
            cartsOnly
            rows={rows}
            period={period}
            onExportView={onExportView}
          />
        )}
      />
    </section>
  );
};
